import { PaywallApi, Plan, PurchaseOptions } from '@accedo/one-plugin-sdk';
import { useEffect, useMemo, useState } from 'react';

import { Actions } from '#/components/PlanPicker/types';
import { PaywallError, usePaywall } from '#/hooks';

export const usePlans = ({
  api,
  error,
  onError,
  isShowing,
}: {
  api?: PaywallApi;
  error?: PaywallError;
  onError: (error: PaywallError) => void;
  isShowing?: boolean;
}) => {
  const [plans, setPlans] = useState<Plan[]>();

  useEffect(() => {
    if (!api?.getPlans || plans || error || !isShowing) {
      return;
    }

    api.getPlans().then(setPlans).catch(onError);
  }, [api, plans, onError, error, isShowing]);

  return plans;
};

export const usePlanPickerActions = (): Actions => {
  const { closePaywall, setError, api, closeHandler } = usePaywall();

  return useMemo(
    () => ({
      getProviderInfo: () =>
        api?.getProviderInfo ? api?.getProviderInfo() : Promise.resolve({}),
      validateVoucher: (planId: string, voucherCode: string) =>
        api?.validateVoucher
          ? api.validateVoucher(planId, voucherCode)
          : Promise.reject('Not implemented: validateVoucher'),
      purchase: (planId: string, options: PurchaseOptions) => {
        return api?.purchase
          ? api.purchase(planId, options)
          : Promise.reject('Not implemented: purchase');
      },
      handleError: setError,
      handleClose: () => {
        if (!closeHandler?.isCancelOnly) {
          closeHandler?.onClose();
        }

        if (!closeHandler?.ignoreDefault) {
          closePaywall();
        }
      },
    }),
    [closePaywall, setError, api, closeHandler]
  );
};
